export default __webpack_public_path__ + "be87693aa0f9e85367e0b289f5899cb4.png";